// extracted by mini-css-extract-plugin
export default {"Spinner":"MessageList_Spinner__T0GE1","entry":"MessageList_entry__qMvlV"};